import React from 'react';
import { PhoneButton } from 'dyl-components';
import {  Grid } from 'semantic-ui-react';

const OfficeViewAnswerButtons = ({
    ignore,
    ignoreDisabled = false,
    answer,
    answerDisabled = false,
    actionButtons,
    press1,
    isDialer
 }) => {
    return (
        <Grid className={`OfficeViewAnswerButtons${isDialer ? ' OfficeViewAnswerButtons--dialer' : ''}`} columns="equal">
            <Grid.Row>
                <Grid.Column>
                    <PhoneButton small={isDialer} text={!press1 ? "Answer" : "Press 1"} icon={`fa-solid fa-${!press1 ? 'phone' : 'hand-back-point-up'}`} iconColor="blue" onClick={answer} disabled={answerDisabled} isClicked={actionButtons?.answer && !press1} />
                </Grid.Column>
                <Grid.Column>
                    <PhoneButton small={isDialer} text="Ignore" icon="fa-solid fa-phone-hangup" iconColor="red" onClick={ignore} disabled={ignoreDisabled} isClicked={actionButtons?.hangup}/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};

export default OfficeViewAnswerButtons;
